export const defaultFormState = {
  codigoPDV: 0,
  descricao: '',
  qtdSemCusto: 0,
  qtdMax: 0,
  qtdMin: 0,
  ativo: true,
  addMaisVezes: 'True',
  borda: 'False',
  incrementar: 1,
  controlaEmbalagem: false,
  cobrancaItemMaiorValor: false,
};
